export default __webpack_public_path__ + "static/media/bg5.e7bd48a8.jpg";